// extracted by mini-css-extract-plugin
export default {"header":"Header_header__UD9oz","header_navbuttons":"Header_header_navbuttons__-OOYV","header_title":"Header_header_title__L9oO9","header_search":"Header_header_search__cM7iM"};